import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function FinalClose() {
  return <Section className="bg-primary text-center pb-32" data-id="element-33">
      <div className="max-w-2xl mx-auto" data-id="element-34">
        <div className="space-y-6 text-xl md:text-2xl text-text-secondary mb-12" data-id="element-35">
          <p data-id="element-36">No necesitas otro video.</p>
          <p data-id="element-37">No necesitas otra plantilla guardada.</p>
          <p className="text-white font-bold text-3xl my-8" data-id="element-38">
            Necesitas una decisión:
          </p>
          <p className="italic" data-id="element-39">
            ¿vas a seguir construyendo… o vas a publicar y cobrar?
          </p>
        </div>

        <div className="mb-12" data-id="element-40">
          <p className="text-accent-blue font-bold tracking-widest uppercase" data-id="element-41">
            1 página. 3 mensajes. 24 horas.
          </p>
        </div>

        <Button variant="primary" className="w-full md:w-auto text-xl px-12 py-5" onClick={() => window.open('https://www.impulsodigitalexpres.com/cart/49920073662710:1', '_blank')} data-id="element-42">
          EMPEZAR AHORA
        </Button>
      </div>
    </Section>;
}